import { useState } from "react";
import { NavLink } from "react-router-dom";
import logo from "../assets/logomask.png";
import { HiOutlineMenu } from 'react-icons/hi'

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const linkStyle =
    "block py-2 px-3 text-gray-700 hover:text-brand transition";

  const activeLink =
    "text-brand font-semibold";

  return (
   <nav className="sticky top-0 z-50 bg-white border-b shadow-sm">
  <div className="relative max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">

    {/* Logo */}
    <div className="text-xl font-bold text-brand">
      <img src={logo} alt="Company logo" className="h-12"/>
    </div>

    {/* Desktop Links */}
    <div className="hidden md:flex absolute left-1/2 transform -translate-x-1/2 space-x-8 items-center">
      <NavLink
        to="/"
        className={({ isActive }) =>
          `${linkStyle} ${isActive ? activeLink : ""}`
        }
      >
        Home
      </NavLink>

      <NavLink
        to="/about"
        className={({ isActive }) =>
          `${linkStyle} ${isActive ? activeLink : ""}`
        }
      >
        About Us
      </NavLink>

      <NavLink
        to="/program"
        className={({ isActive }) =>
          `${linkStyle} ${isActive ? activeLink : ""}`
        }
      >
        Programs
      </NavLink>
    </div> 

    {/* CTA */}
    <div className="hidden md:flex">
     <NavLink to="/contact">
  <button className="bg-brand text-white px-5 py-2 rounded-md hover:bg-brand-secondary transition">
    Contact Us
  </button>
</NavLink>
    </div>

    {/* Hamburger */}
    <button
      className="md:hidden"
      onClick={() => setMenuOpen(!menuOpen)}
    >
      {/* ☰ */} <HiOutlineMenu className="w-8 h-8"/>
    </button>

  </div>

  {/* Mobile Menu */}
  {menuOpen && (
    <div className="md:hidden px-6 pb-4 space-y-3">

      <NavLink
        to="/"
        className={({ isActive }) =>
          `${linkStyle} ${isActive ? activeLink : ""}`
        }
        onClick={() => setMenuOpen(false)}
      >
        Home
      </NavLink>

      <NavLink
        to="/about"
        className={({ isActive }) =>
          `${linkStyle} ${isActive ? activeLink : ""}`
        }
        onClick={() => setMenuOpen(false)}
      >
        About Us
      </NavLink>

      <NavLink
        to="/program"
        className={({ isActive }) =>
          `${linkStyle} ${isActive ? activeLink : ""}`
        }
        onClick={() => setMenuOpen(false)}
      >
        Programs
      </NavLink>

      <NavLink to="/contact" onClick={() => setMenuOpen(false)}>
  <button className="w-full bg-brand-secondary text-white py-2 rounded-md hover:bg-brand transition">
    Contact Us
  </button>
</NavLink>

    </div>
  )}
</nav>
  );
}

export default Navbar;